// Handle window Resize

// MobileState
const mobileActive = {status: false};

let body = document.querySelector('body');

const breakpoint_lg = 992;

function reportWindowSize() {

    let bodySize = body.offsetWidth;

    if (bodySize >= breakpoint_lg) {
        setMobileState(false);
        return;
    }

    setMobileState(true);

}

function setMobileState(state) {
    if (state) {
        body.classList.add('is-mobile-active');
        body.classList.remove('is-desktop-active');
        mobileActive.status = true
        return
    }
    body.classList.remove('is-mobile-active');
    body.classList.add('is-desktop-active');
    mobileActive.status = false
}

window.onresize = reportWindowSize;
reportWindowSize();

export { mobileActive }
